import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import './EndpointsForm.css';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectEndpointsById, valuesAnalyze, changeViewForms, exportUpdateEndpoints, exportSelectAllMohs } from '../../../services';
import Loading from '../../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState([]);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [mohs, setMohs] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchMohs = async (idtenant) => {
    try {
      const response = await exportSelectAllMohs();
      if (response && response.status === 200 && response.data) {
        let filteredMohs = response.data;
        if (idtenant && !idtenant.includes('vgs')) {
          filteredMohs = response.data.filter((moh) => idtenant.includes(moh.accountcode));
        }
        setMohs(filteredMohs);
      }
    } catch (error) {
      console.error("Erro ao buscar músicas de espera:", error);
    }
  };

  const fetchEndpoints = async () => {
    const endpointsList = await exportSelectEndpointsById(itemsSelectedToEdit);
    if(endpointsList <= 0) return history.push('/config/ramal/lista');
    if(endpointsList === undefined) setLoading(true);
    const elements = endpointsList.map((element) => {
      const { transportname, languagename, busy, capturegroup, contextname, callgroup, pass, moh_suggest } = element;
      element['transport'] = transportname;
      element['language'] = languagename;
      element['state'] = busy;
      element['pickupGroup'] = capturegroup;
      element['context'] = contextname;
      element['callGroup'] = callgroup;
      element['password'] = pass;
      element['moh'] = moh_suggest;
      element['maxContacts'] = element.maxcontacts || 1;

      delete element.transportname;
      delete element.languagename;
      delete element.capturegroup;
      delete element.contextname;
      delete element.callgroup;
      delete element.pass;
      delete element.moh_suggest;
      delete element.maxcontacts;

      return element;
    });

    setValues(...elements);
    setPhones(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    await fetchMohs(idtenant);
    const elements = await fetchEndpoints();
    return;
  }, [history]);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTripleChar } = valuesAnalyze;

    if(name === 'first' || name === 'qtt' || name === 'state' || name === 'maxContacts') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'maxContacts' && (value < 1 || value > 10)) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'callGroup'|| name === 'pickupGroup') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeCodec = (name, value) => {
    let prevSetValueCodec = values[name];

    if (prevSetValueCodec.length > 0 && typeof prevSetValueCodec === 'string') prevSetValueCodec = prevSetValueCodec.split(',');
    prevSetValueCodec = prevSetValueCodec.includes(`${value}`) ? prevSetValueCodec.filter((codec) => codec !== value) : [...prevSetValueCodec, value];

    prevSetValueCodec.toString();

    setValues((prevState) => prevState, values[name] = prevSetValueCodec);
    return;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    if (name === 'codec') handleChangeCodec(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    if (name !== 'codec') setValues((prevState) => prevState, values[name] = value );
    if(!Object.keys(validate).includes(false)) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);

    return;
  };

  const sendDataEndpointsUpdate = async () => {
    const objectForUpdate = { elements: itemsSelectedToEdit, ...values };
    const fetchItensUpdate = await exportUpdateEndpoints(objectForUpdate);
    history.push('/config/ramal/lista');
    return;
  };
  
  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div className="endpoints-form-container">
          <div className="endpoints-form-header">
            <div className="endpoints-form-title-wrapper">
              <svg className="endpoints-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <div>
                <h1 className="endpoints-form-title">Editar Ramais</h1>
                <p className="endpoints-form-subtitle">Altere as configurações dos ramais selecionados</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-endpoints-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-endpoints-not-delete')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível deletar os ramais selecionados.
              </div>
            </div>

            <div id="alert-endpoints-not-selected" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-endpoints-not-selected')}>×</button>
              </div>
              <div className="alert-body">
                Nenhum ramal selecionado!
              </div>
            </div>

            <div id="alert-create-endpoints" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Ramais atualizados com sucesso!
              </div>
            </div>
          </div>

          <div className="endpoints-table-preview">
            <table>  
                <thead>
                    <tr>
                    <th>Ramal</th>
                    <th>Senha</th>
                    <th>Nome</th>
                    <th>Protocolo</th>
                    <th>Previlégios</th>
                    <th>DTMF</th>
                    <th>Linguagem</th>
                    <th>Codec</th>
                    <th>NAT</th>
                    <th>Ocupado</th>
                    <th>Max. Disp.</th>
                    <th>Grupo Atendedor</th>
                    <th>Grupo de Captura</th>
                    </tr>
                </thead>
                <tbody>
                {
                  phones.map((phone) => {
                    const { endpoint, password, callerid, transport, context, language, codec, dtmf, state, maxContacts, callGroup, pickupGroup, nat } = phone;
                    return (
                      <tr key={endpoint}>
                        <td>{endpoint}</td>
                        <td>{password}</td>
                        <td>{callerid}</td>
                        <td>{transport}</td>
                        <td>{context}</td>
                        <td>{dtmf}</td>
                        <td>{language}</td>
                        <td>{codec.toString()}</td>
                        <td>{nat}</td>
                        <td>{state}</td>
                        <td>{maxContacts || 1}</td>
                        <td>{callGroup}</td>
                        <td>{pickupGroup}</td>
                      </tr>)
                    })
                }
              </tbody>
            </table>
          </div>

          <div className="form-divider"></div>
          <form name="create-form" id="create-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-card">
              <div className="form-section-title">Editar Configurações</div>
              
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Senha</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="password" 
                      type="text" 
                      defaultValue={values['password']} 
                      onBlur={(e) => handleChangeValues(e.target)} 
                    />
                    <span name="password-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Nome</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="callerid" 
                      type="text" 
                      defaultValue={values['callerid']} 
                      onBlur={(e) => handleChangeValues(e.target)} 
                    />
                    <span name="callerid-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Protocolo</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="transport"  
                      defaultValue={values['transport']} 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="udp_transport">UDP</option>
                      <option value="tcp_transport">TCP</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">DTMF</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="dtmf" 
                      defaultValue={values['dtmf']} 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="rfc2833">RFC-2833</option>
                      <option value="info">INFO</option>
                      <option value="shortinfo">SHORTINFO</option>
                      <option value="inband">IN-BAND</option>
                      <option value="auto">AUTO</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field-full">
                  <div className="codec-group">
                    <div className="codec-group-title">Codecs</div>
                    <div className="codec-options">
                      <div className="codec-option">
                        <label>ALAW</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="alaw" 
                          defaultChecked={values['codec'].includes('alaw')} 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>ULAW</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="ulaw" 
                          defaultChecked={values['codec'].includes('ulaw')} 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>G.729</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="g729" 
                          defaultChecked={values['codec'].includes('g729')} 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>H.264</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="h264" 
                          defaultChecked={values['codec'].includes('h264')} 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Linguagem</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="language" 
                      defaultValue={values['language']} 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="en">Inglês</option>
                      <option value="pt_BR">Português</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">NAT</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="nat" 
                      defaultValue={values['nat']} 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="no">Não</option>
                      <option value="yes">Sim</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Chamadas Simultâneas</label>
                  <div className="form-control">
                    <input
                      className="form-input"
                      name="state"
                      type="text"
                      defaultValue={values['state']}
                      onChange={(e) => handleChangeValues(e.target)}
                    />
                    <span name="state-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Max. Dispositivos</label>
                  <div className="form-control">
                    <input
                      className="form-input"
                      name="maxContacts"
                      type="text"
                      defaultValue={values['maxContacts']}
                      onChange={(e) => handleChangeValues(e.target)}
                    />
                    <span name="maxContacts-invalid-data" className='form-error is-hidden'>Valor deve ser entre 1 e 10!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="tenant" 
                      type="text" 
                      defaultValue={values['tenant']} 
                      onChange={(e) => handleChangeValues(e.target)} 
                    />
                    <span name="tenant-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Grupo de Chamada</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="callGroup" 
                      type="text" 
                      defaultValue={values['callGroup']} 
                      onChange={(e) => handleChangeValues(e.target)} 
                    />
                    <span name="callGroup-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Grupo de Captura</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="pickupGroup" 
                      type="text" 
                      defaultValue={values['pickupGroup']} 
                      onChange={(e) => handleChangeValues(e.target)} 
                    />
                    <span name="pickupGroup-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Previlégios</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="context" 
                      type="text" 
                      defaultValue={values['context']} 
                      onChange={(e) => handleChangeValues(e.target)} 
                    />
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Música de Espera</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="moh" 
                      defaultValue={values['moh'] || ''} 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Padrão (tenant)</option>
                      {mohs.filter((moh) => moh.name !== 'default').map((moh) => (
                        <option key={moh.name} value={moh.name}>
                          {moh.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <Link to="/config/ramal/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faTimes} />
                  Cancelar
                </Link>
                <button 
                  className="btn-submit" 
                  type="submit" 
                  onClick={() => sendDataEndpointsUpdate()} 
                  disabled={disable}
                >
                  <FontAwesomeIcon icon={faSave} />
                  Salvar Alterações
                </button>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  );
}

export default EndpointsListById;
